import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";

import { AppLayout } from "../components/appLayout";
import useApiClient from "../hooks/useApiClient";
import { CategoryWithCountsViewModel } from "../apiClient";
import { BookmarkAddEditForm } from "../components/forms/bookmarkAddEditForm";

export const BookmarkAdd = () => {
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const initialUrl = searchParams.get('url') ?? undefined;
    const [categories, setCategories] = useState<CategoryWithCountsViewModel[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!apiClient) return;

        const loadCategories = async () => {
            const categories = await apiClient.categoriesAll();
            setCategories(categories);
            setLoading(false);
        };

        loadCategories();
    }, [apiClient]);

    return (
        <AppLayout loading={loading}>
            <Container className="py-2">
                <Breadcrumb>
                    <LinkContainer to={`/bookmarks`}>
                        <Breadcrumb.Item>Bookmarks</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>Add bookmark</Breadcrumb.Item>
                </Breadcrumb>

                <div className="mb-3">
                    <h1 className="mb-1">Add bookmark</h1>
                    <p className="text-body-secondary mb-0">
                        Save a link to your bookmarks for later viewing or import.
                    </p>
                </div>

                <Card>
                    <Card.Body className="p-4">
                        <BookmarkAddEditForm
                            apiClient={apiClient!}
                            initialUrl={initialUrl}
                            categories={categories}
                            onSave={() => navigate(`/bookmarks`)}
                        />
                    </Card.Body>
                </Card>
            </Container>
        </AppLayout>
    );
};